import React from 'react';

import cx from 'classnames';
import {
  SkeletonProfileImage,
  SkeletonBody,
  SkeletonImage,
} from '@xingternal/skeleton';

import styles from './styles.css';

type LoadingSkeletonProps = {
  smallActor: boolean;
}

const LoadingSkeleton = ({ smallActor = false }: LoadingSkeletonProps) => (
  <div className={styles.item}>
    <div
      className={cx(styles.actor, styles.skeletonActor, {
        [styles.smallActorSkeleton]: smallActor,
      })}
    >
      {!smallActor && (
        <div className={styles.actorImgAnchor}>
          <SkeletonProfileImage size="small" className={styles.actorImg} />
        </div>
      )}
      <div className={cx(styles.actorContent, styles.skeletonActorContent)}>
        <SkeletonBody
          variant="primary"
          amountRows={smallActor ? 1 : 2}
        />
      </div>
    </div>
    <div className={styles.content}>
      <div className={cx(styles.skeletonBody, styles.grow)}>
        <SkeletonBody
          size="primary"
          amountRows={4}
          className={styles.fullWidth}
        />
      </div>
      <SkeletonImage
        variant="primary"
        className={cx(styles.contentImg, styles.skeletonImage)}
      />
    </div>
  </div>
);

export default LoadingSkeleton;
